import Input from '../../../../components/atoms/input';
import UploadAvatarCard from '../../../../components/organisms/upload-avatar-card';
import useWorkspaceCreation from '../../../../context/WorkspaceCreationContext';
import useDebounce from '../../../../utils/debounce';

const WorkspaceProfileDetails = () => {
  // init
  const { workspaceProfileName, workspaceProfileLogo, setWorkspaceProfileName, setWorkspaceProfileLogo, errors, removeError } = useWorkspaceCreation();

  // states
  const [debouncedWorkspaceProfileName] = useDebounce(workspaceProfileName, 500);

  const handleWorkspaceProfileNameChange = (event) => {
    if (event.target.value) removeError('workspaceProfileName');
    setWorkspaceProfileName(event.target.value);
  };

  const handleAvatarRemove = () => {
    setWorkspaceProfileLogo({ blob: undefined, dataURI: undefined, file: undefined });
  };

  return (
    <div className="workspace-creation-step-body">
      <h2 className="step-title">Complete your profile</h2>
      {/* Workspace Profile name */}
      <div className="border-cards">
        <div className="border-card">
          <span className="border-card-title">How do you want your name to appear?</span>
          <div className="border-card-input-container">
            <span className="border-card-label">Full name</span>
            <Input error={!!errors.workspaceProfileName} helperText={errors.workspaceProfileName} autoFocus placeholder="Enter full name" onChange={handleWorkspaceProfileNameChange} value={workspaceProfileName} />
          </div>
        </div>
        {/* Workspace Profile Logo */}
        <UploadAvatarCard name={debouncedWorkspaceProfileName} title="Upload your profile photo." uploadButtonText="Upload Photo" isOptional avatar={workspaceProfileLogo.dataURI} onUpload={setWorkspaceProfileLogo} onRemove={handleAvatarRemove} />
      </div>
    </div>
  );
};

export default WorkspaceProfileDetails;
